<template>
  <ModalBase show-modal auto-h narrow @close-modal="close" class="gk-modal-invoice-payments-convert">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          {{ $gettext('Convert to euro') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>

      <!-- Payment add form -->
      <p style="font-size: 1rem;">{{ $gettext('This invoice is in a foreign currency, in order for it to be added to your gekko bookkeeping it will need to be converted to euro\'s. You can calculate the total through a set exchange rate or provide an amount manually.') }}</p>
      <div>
        <b-form-group id="input-group-exchange" class="vat-input-size" label-class="gk-label-margin gk-modal-label" label-for="input-exchange">
          <template slot="label">
            {{ $gettext('Exchange rate') + ' (' + 'EUR' + ' / ' + invoice.currency + ')'}}
          </template>
          <b-input-group>
            <template #append>
              <b-input-group-text class="btn" @click="exchangeRateTotal()">
                <font-awesome-icon icon="fa-regular fa-calculator" class="append-icon" />
              </b-input-group-text>
            </template>
            <b-form-input id="input-exchange" type="number" v-model="exchangeRate" placeholder="0.0" step="0.01" />
          </b-input-group>
        </b-form-group>
        <b-form-group id="input-group-invoice-amount" label-class="gk-label-margin gk-modal-label" :label="$gettext('Invoice total')" label-for="input-invoice-amount">
          <b-form-input id="input-invoice-amount" v-model="invoiceAmount" />
          <div class="gk-input-error">
            {{ errors.invoiceAmount }}
          </div>
        </b-form-group>
      </div>
      
    </template>
    <template v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Cancel')"
        variant="light"
      />
      <GekkoButton
        @click="$emit('update-euro-total', false)"
        :text="$gettext('Update EUR total')"
        variant="primary"
      />
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ModalBase from "@/components/base_components/ModalBase"
import TitleBar from "@/components/TitleBar"
import GekkoButton from "@/components/GekkoButton"

export default {
  name: 'InvoiceUpdateEURModal',

  components: { 
    ModalBase,
    TitleBar,
    GekkoButton
  },
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      exchangeRate: 0,
    }
  },
  computed: {
    ...mapGetters({ 
      invoice: "invoices/getInvoice",
      exchangeRates: "invoices/getExchangeRates",
    }),
    invoiceAmount: {
      get () { return this.value },
      set (invoiceAmount) { this.$emit('input', invoiceAmount) }
    },
  },
  watch: {

  },
  created () {
    this.setupData()
  },
  mounted () {
    document.body.classList.add('modal-on')
  },
  methods: {
    ...mapActions({ 
      loadExchangeRates: 'invoices/loadExchangeRates',
    }),
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    setupData () {
      if (this.invoice.currency !== 'EUR') {
        if (!this.exchangeRates) {
          this.loadExchangeRates().then(() => {
            const this_rate = this.exchangeRates.find(item => item.to_currency === this.invoice.currency)
            if (this_rate) {
              this.exchangeRate = this_rate.exchange_rate
            }
          })
        } else {
          const this_rate = this.exchangeRates.find(item => item.to_currency === this.invoice.currency)
          if (this_rate) {
            this.exchangeRate = this_rate.exchange_rate
          }
        }
      }
    },
    exchangeRateTotal () {
      if (this.exchangeRate && this.exchangeRate > 0) {
        this.invoiceAmount = parseFloat(this.invoice.currency_total_amount / this.exchangeRate).toFixed(2)
      } else {
        this.invoiceAmount = 0
      }
    },
  }
}
</script>

<style lang="scss">
.gk-modal-invoice-payments-convert {
  .gk-modal {
    max-width: 530px !important;
    .invoice-section--label {
      font-size: 1rem;
    }
    .action-buttons-wrapper {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
    }
  }
}
</style>